import React, { Fragment, useState } from 'react';
import SSCERecordUpload from '../SSCE/SSCERecordUpload';
import DocumentUpload from '../DocumentUpload/DocumentUpload';

interface ApplicationStage4Props {
  ssceLoading: boolean;
  currentSitting: string;
  // generateOcr: () => void;
  ssce: any;
  ninValidated: boolean;
  boxErrorMessage: string;
  displayForm: boolean;
  examNoError: string | undefined;
  register: any;
  errors: any;
  states: any[];
  subArray: any;
  lgas: any[];
  formData: any;
  institutionRow: {
    degreeTitle: string;
    institutionName: string;
    degreeCertificateNumber: string;
    degreeAwarded: string;
    graduationYear: string;
    first_degreeTitle?: string;
    first_institutionName?: string;
    first_degreeCertificateNumber?: string;
    first_degreeAwarded?: string;
    first_graduationYear?: string;
    other_degree?: string;
    other_degreeAwarded?: string;
    other_graduationYear?: string;
  }[];
  handleCertificateChange: (
    index: number,
    event: React.ChangeEvent<any>
  ) => void;
  changeFormData: (e: React.ChangeEvent<any>) => void;
  ssceFormRow: { examType: string; examNo: string; examYear: string }[];
  handleAddFormRow: (
    e: React.MouseEvent<HTMLButtonElement, MouseEvent>
  ) => void;
  handleFormRowInputChange: (
    index: number,
    event: React.ChangeEvent<any>
  ) => void;
  handleRemoveFormRow: (index: number) => void;
  validateFormRow: () => boolean;
  sittings: number;
  setSittings: (value: number) => void;
  handleFirstSittingChange: (e: React.ChangeEvent<any>) => void;
  currentDocument: string;
  changeCurrentDocument: (e: React.ChangeEvent<HTMLSelectElement>) => void;
  documentError: string;
  getRootProps: () => any;
  getInputProps: () => any;
  isDragActive: boolean;
  radioForm: string;
  documents: { [key: string]: string };
  resultError: string | undefined;
  consent: boolean;
  loading: {
    submit: boolean;
    nimc: boolean;
    jamb: boolean;
    step1: boolean;
    step2: boolean;
  };
  getDocumentsUploadProgress: () => number;
  documentsMapper: (key: string) => string;
  setCurrentSitting: (value: string) => void;
  setCurrentPage: (page: number) => void;
  currentPage: number;
  removeDocument: (key: string) => void;
  handleSecondSittingChange: (e: React.ChangeEvent<any>) => void;
  changeConsent: (e: React.ChangeEvent<any>) => void;
  manifestInfo: any;
  loadAssert: any
}

export default function ApplicationStage4 (props: ApplicationStage4Props) {
  const [examValidator, setExamValidator] = useState({ examType: '', examYear: '', examNo: '' })
  const [selectMaster, setSelectMaster] = React.useState<string>('');
  const allRowsComplete = props.institutionRow.every(
    (row) =>
      row &&
      row.degreeTitle &&
      row.institutionName &&
      row.graduationYear &&
      row.degreeCertificateNumber &&
      row.degreeAwarded
  );
  // if(props.manifestInfo.ssce1.upload)
  // console.log('allRowsComplete', props);
  // const jobDetails = jobVancacy.dataset.categoryAttribute[props.radioForm as keyof typeof jobVancacy.dataset.categoryAttribute];
  // console.log('jobDetails', jobDetails)
  return (
    <div>
      {props.ninValidated && !props.boxErrorMessage && (
        <>
          {(props.radioForm === 'sp-asp-insp' || props.radioForm === 'sp-asp2-insp2') && <section
            className={` border-0 rounded${
              !props.ninValidated || props.boxErrorMessage ? ' d-none' : ''
            } ${!props.displayForm ? ' d-none' : 'd-block'}`}
            id='doc'
          >
            <div className='bg-white'>
              <div className='section-container'>
                <div className='section-item-container'></div>
                <div className='p-1'>
                  <h3 className='sub-heading__pinfo'>Degree Details</h3>
                </div>
                <div className='section-item-container'></div>
                <div className='my-4 container'>
                  {props.institutionRow.length > 0 && (
                    <>
                      {props.institutionRow.map((field, index) => (
                        <div key={index} className='row row-cols-3  mx-4 '>
                          <div className='col-sm-3'>
                            <div className='form-group'>
                              <label>Degree Title</label>
                              <select
                                className='form-control'
                                // {...props.register()}
                                required
                                onChange={(event) => {
                                  props.handleCertificateChange(index, event);
                                  setSelectMaster(event.target.value);
                                }}
                                name='degreeTitle'
                              >
                                {field.degreeTitle
                                  ? (
                                  <option>{field.degreeTitle}</option>
                                    )
                                  : (
                                  <option>
                                    --Please choose degree title--
                                  </option>
                                    )}
                                <option>HND</option>
                                <option>BSC</option>
                                <option>MSC</option>
                              </select>
                            </div>
                          </div>

                          <div className='col-sm-12'>
                            <div className='form-group'>
                              <label>Institution Name</label>
                              <input
                                type='text'
                                name='institutionName'
                                className='form-control'
                                required
                                onChange={(event) =>
                                  props.handleCertificateChange(index, event)
                                }
                                value={field.institutionName}
                              />
                            </div>
                          </div>
                          <div className='col-sm-3'>
                            <div className='form-group'>
                              <label>Degree Certificate Number</label>
                              <input
                                type='text'
                                name='degreeCertificateNumber'
                                className='form-control'
                                required
                                onChange={(event) =>
                                  props.handleCertificateChange(index, event)
                                }
                                value={field.degreeCertificateNumber}
                              />
                            </div>
                          </div>
                          <div className='col-sm-3'>
                            <div className='form-group'>
                              <label>Degree Awarded</label>
                              {/* <input
                                type='text'
                                name='degreeAwarded'
                                className='form-control'
                                onChange={(event) =>
                                  props.handleFormRowInputChange(index, event)
                                }
                                value={field.degreeAwarded}
                              /> */}
                              <select
                                className='form-control mr-2'
                                onChange={(event) => {
                                  props.handleCertificateChange(index, event);
                                }}
                                name='degreeAwarded'
                              >
                                <option>
                                  --Please choose degree awarded--
                                </option>
                                {/* <option>Distinction</option> */}
                                <option>First Class</option>
                                <option>Second Class Upper</option>
                                <option>Second Class Lower</option>
                                <option>Third Class</option>
                                <option>Pass</option>
                              </select>
                            </div>
                          </div>

                          <div className='col-sm-3'>
                            <div className='form-group'>
                              <label>Graduation Year</label>
                              <select
                                className='form-control'
                                name='graduationYear'
                                onChange={(event) =>
                                  props.handleCertificateChange(index, event)
                                }
                              >
                                {field.graduationYear
                                  ? (
                                  <option>{field.graduationYear}</option>
                                    )
                                  : (
                                  <option>--Please choose year--</option>
                                    )}
                                {Array.from(
                                  { length: 25 },
                                  (_, i) => 2030 - i
                                ).map((year) => (
                                  <option key={year}>{year}</option>
                                ))}
                              </select>
                            </div>
                          </div>
                        </div>
                      ))}
                    </>
                  )}
                  {selectMaster === 'MSC' && allRowsComplete && (
                    <>
                      {props.institutionRow.map((field, index) => (
                        <Fragment key={index}>
                          <p className='text-danger mx-5 fst-italic fs-6 my-3'>
                            <em>
                              If you are using a Master&apos;s degree, please
                              also attach your first-degree certificate.
                            </em>
                          </p>
                          <div className='row row-cols-3 mx-4'>
                            <div className='col-sm-3'>
                              <div className='form-group'>
                                <label>Degree Title</label>
                                <select
                                  className='form-control'
                                  onChange={(event) =>
                                    props.handleCertificateChange(index, event)
                                  }
                                  name='first_degreeTitle'
                                >
                                  {field.first_degreeTitle
                                    ? (
                                    <option>{field.first_degreeTitle}</option>
                                      )
                                    : (
                                    <option>
                                      --Please choose degree title--
                                    </option>
                                      )}
                                  <option>HND</option>
                                  <option>BSC</option>
                                </select>
                              </div>
                            </div>

                            <div className='col-sm-12'>
                              <div className='form-group'>
                                <label>Institution Name</label>
                                <input
                                  type='text'
                                  name='first_institutionName'
                                  className='form-control'
                                  onChange={(event) =>
                                    props.handleCertificateChange(index, event)
                                  }
                                  value={field.first_institutionName}
                                />
                              </div>
                            </div>
                            <div className='col-sm-3'>
                              <div className='form-group'>
                                <label>Degree Certificate Number</label>
                                <input
                                  type='text'
                                  name='first_degreeCertificateNumber'
                                  className='form-control'
                                  onChange={(event) =>
                                    props.handleCertificateChange(index, event)
                                  }
                                  value={field.first_degreeCertificateNumber}
                                />
                              </div>
                            </div>
                            <div className='col-sm-3'>
                              <div className='form-group'>
                                <label>Degree Awarded</label>
                                {/* <input
                                type='text'
                                name='degreeAwarded'
                                className='form-control'
                                onChange={(event) =>
                                  props.handleFormRowInputChange(index, event)
                                }
                                value={field.degreeAwarded}
                              /> */}
                                <select
                                  className='form-control mr-2'
                                  onChange={(event) => {
                                    props.handleCertificateChange(index, event);
                                  }}
                                  name='first_degreeAwarded'
                                >
                                  {field.first_degreeAwarded
                                    ? (
                                    <option>{field.first_degreeAwarded}</option>
                                      )
                                    : (
                                    <option>
                                      --Please choose degree awarded--
                                    </option>
                                      )}
                                  <option>First Class</option>
                                  <option>Second Class Upper</option>
                                  <option>Second Class Lower</option>
                                  <option>Third Class</option>
                                  <option>Pass</option>
                                </select>
                              </div>
                            </div>

                            <div className='col-sm-3'>
                              <div className='form-group'>
                                <label>Graduation Year</label>
                                <select
                                  className='form-control'
                                  name='first_graduationYear'
                                  onChange={(event) =>
                                    props.handleCertificateChange(index, event)
                                  }
                                >
                                  {field.first_graduationYear
                                    ? (
                                    <option>
                                      {field.first_graduationYear}
                                    </option>
                                      )
                                    : (
                                    <option>--Please choose year--</option>
                                      )}
                                  {Array.from(
                                    { length: 25 },
                                    (_, i) => 2030 - i
                                  ).map((year) => (
                                    <option key={year}>{year}</option>
                                  ))}
                                </select>
                              </div>
                            </div>
                          </div>
                        </Fragment>
                      ))}
                    </>
                  )}
                    <>
                      {props.institutionRow.map((field, index) => (
                        <Fragment key={index}>
                          <p className='text-danger mx-5 fst-italic fs-6 my-3'>
                            <em>
                              If you have another other degree relevant to this application, please upload it below.
                            </em>
                          </p>
                          <div className='row row-cols-2 mx-4'>
                            <div className='col-sm-3'>
                              <div className='form-group'>
                                <label>Degree Title</label>
                                <input
                                  type='text'
                                  name='other_degree'
                                  className='form-control'
                                  onChange={(event) =>
                                    props.handleCertificateChange(index, event)
                                  }
                                  value={field.other_degree}
                                />
                              </div>
                            </div>
                            <div className='col-sm-3'>
                              <div className='form-group'>
                                <label>Degree Certificate Number</label>
                                <input
                                  type='text'
                                  name='first_degreeCertificateNumber'
                                  className='form-control'
                                  onChange={(event) =>
                                    props.handleCertificateChange(index, event)
                                  }
                                  value={field.first_degreeCertificateNumber}
                                />
                              </div>
                            </div>
                            <div className='col-sm-3'>
                              <div className='form-group'>
                                <label>Degree Awarded</label>
                                {/* <input
                                type='text'
                                name='degreeAwarded'
                                className='form-control'
                                onChange={(event) =>
                                  props.handleFormRowInputChange(index, event)
                                }
                                value={field.degreeAwarded}
                              /> */}
                                <input
                                  type='text'
                                  name='other_degreeAwarded'
                                  className='form-control'
                                  onChange={(event) =>
                                    props.handleCertificateChange(index, event)
                                  }
                                  value={field.other_degreeAwarded}
                                />
                              </div>
                            </div>

                            <div className='col-sm-3'>
                              <div className='form-group'>
                                <label>Graduation Year</label>
                                <select
                                  className='form-control'
                                  name='first_graduationYear'
                                  onChange={(event) =>
                                    props.handleCertificateChange(index, event)
                                  }
                                >
                                  {field.first_graduationYear
                                    ? (
                                    <option>
                                      {field.first_graduationYear}
                                    </option>
                                      )
                                    : (
                                    <option>--Please choose year--</option>
                                      )}
                                  {Array.from(
                                    { length: 25 },
                                    (_, i) => 2030 - i
                                  ).map((year) => (
                                    <option key={year}>{year}</option>
                                  ))}
                                </select>
                              </div>
                            </div>
                          </div>
                        </Fragment>
                      ))}
                    </>
                </div>
              </div>
            </div>
          </section>}
          <section
            className={` border-0 rounded${
              !props.ninValidated || props.boxErrorMessage ? ' d-none' : ''
            } ${!props.displayForm ? ' d-none' : 'd-block'}`}
            id='doc'
          >
            <div className='bg-white'>
              <div className='section-container'>
                <div className='section-item-container'></div>
                <div className='section-item-container p-1'>
                  <h3 className='sub-heading__pinfo'>SSCE Details</h3>
                </div>
                <div className='section-item-container'></div>
                <div className='section-item-containers container'>
                  {props.ssceFormRow.length > 0 && (
                    <>
                      {props.ssceFormRow.map((field, index) => (
                        <div key={index} className='row my-4 ml-4 '>
                          <div className='col-sm-3'>
                            <div className='form-group'>
                              <label>Exam Type</label>
                              <select
                                className='form-control'
                                onChange={(event) => {
                                  // console.log('EVENR', event.target.value);
                                  setExamValidator({ ...examValidator, examType: event.target.value })
                                  props.handleFormRowInputChange(index, event)
                                }
                                }
                                name='examType'
                              >
                                {field.examType
                                  ? (
                                  <option>{field.examType}</option>
                                    )
                                  : (
                                  <option>--Please choose exam type--</option>
                                    )}
                                <option>NECO</option>
                                <option>WAEC</option>
                                <option>GCE</option>
                                <option>NABTEB</option>
                              </select>
                            </div>
                          </div>

                          <div className='col-sm-3'>
                            <div className='form-group'>
                              <label>Exam Number</label>
                              <input
                                type='text'
                                name='examNo'
                                className='form-control'
                                onChange={(event) => {
                                  setExamValidator({ ...examValidator, examNo: event.target.value });
                                  props.handleFormRowInputChange(index, event)
                                }
                                }
                                value={field.examNo}
                              />
                            </div>
                          </div>

                          <div className='col-sm-3'>
                            <div className='form-group'>
                              <label>Exam Year</label>
                              <select
                                className='form-control'
                                name='examYear'
                                required
                                onChange={(event) => {
                                  setExamValidator({ ...examValidator, examYear: event.target.value });
                                  props.handleFormRowInputChange(index, event)
                                }
                                }
                              >
                                {field.examYear
                                  ? (
                                  <option>{field.examYear}</option>
                                    )
                                  : (
                                  <option>--Please choose year--</option>
                                    )}
                                  <option>2025</option>
                                    <option>2024</option>
                                <option>2023</option>
                                <option>2022</option>
                                <option>2021</option>
                                <option>2020</option>
                                <option>2019</option>
                                <option>2018</option>
                                <option>2017</option>
                                <option>2016</option>
                                <option>2015</option>
                              </select>
                            </div>
                          </div>
                          {props.ssceFormRow.length < 2 && (
                            <div className='w-100 text-start mx-3 my-2 '>
                              <button
                                className='btn btn-success mb-4 fw-bold'
                                onClick={(e) => props.handleAddFormRow(e)}
                              >
                                Add more +
                              </button>
                            </div>
                          )}
                          <div className='col-sm-3 mt-4'>
                            {index !== 0 && (
                              <button
                                className='btn btn-success'
                                onClick={() => props.handleRemoveFormRow(index)}
                              >
                                remove{' '}
                              </button>
                            )}
                          </div>
                        </div>
                      ))}
                    </>
                  )}
                </div>
              </div>
            </div>
          </section>

          <DocumentUpload
            ninValidated={props.ninValidated}
            boxErrorMessage={props.boxErrorMessage}
            displayForm={props.displayForm}
            validateFormRow={props.validateFormRow}
            setSittings={props.setSittings}
            getDocumentsUploadProgress={props.getDocumentsUploadProgress}
            currentDocument={props.currentDocument}
            changeCurrentDocument={props.changeCurrentDocument}
            sittings={props.sittings}
            documentError={props.documentError}
            selectMaster={selectMaster}
            radioForm={props.radioForm}
            getRootProps={props.getRootProps}
            getInputProps={props.getInputProps}
            isDragActive={props.isDragActive}
            documents={props.documents}
            documentsMapper={props.documentsMapper}
            removeDocument={props.removeDocument}
            manifestInfo={props.manifestInfo}
          />

          <section className={' border-0 d-none rounded'} id='doc'>
            <div className='bg-white d-none'>
              <div className='section-container'>
                <div className='section-item-container'></div>
                <div className='col-md-12 w-100 subheading text-white text-center card-header section-header-bg'>
                  <h1>Verify Result</h1>
                </div>
                <div className='section-item-container'></div>
              </div>
              <div className='row m-0 p-0'>
                <div className='col-md-6 offset-md-3 p-3 bg-white text-center'>
                  <div className='card'>
                    <div className='card'>
                      <div className='card-header  text-white section-header-bg'>
                        <i className='fa fa-info bg rounded p-1'></i> Input your
                        5 credit score
                      </div>
                      <div className='card-body p-2 h-5'>
                        <div className='form-group col-md-12 padleft'>
                          <label className='control-label' htmlFor='gender'>
                            OLevel number of sittings
                            <span id='compulsory'>*</span>
                          </label>
                          <div className='input-group'>
                            <div className='input-group-prepend'>
                              <div className='input-group-text'>
                                <i className='fa fa-file text-default'></i>
                              </div>
                            </div>
                            <select
                              className='form-control'
                              onChange={(e) =>
                                props.setCurrentSitting(e.target.value)
                              }
                            >
                              <option value=''>--sittings--</option>
                              <option value='firstSitting'>1 Sitting</option>
                              <option value='secondSitting'>2 Sitting</option>
                            </select>
                          </div>
                          <small className='error-value'>
                            {props.resultError}
                          </small>
                        </div>

                        {props.ssceLoading && (
                          <div className='mt-4 text-danger'>
                            {' '}
                            Please wait while we verify your ssce result.
                          </div>
                        )}
                        {(props.currentSitting === 'firstSitting' ||
                          props.currentSitting === 'secondSitting') && (
                          <div className='form-group col-md-12 padleft'>
                            <span
                              className={
                                props.ninValidated
                                  ? 'btn btn-success'
                                  : 'btn btn-default'
                              }
                              // onClick={props.generateOcr}
                            >
                              {props.ssce && (
                                <i className='fa fa-check text-light'></i>
                              )}
                              {props.ssce ? ' Verified' : 'Verify'}
                            </span>
                            {props.ssceLoading && (
                              <div
                                style={{ marginTop: 10 }}
                                className='spinner-border spinner-border-sm'
                              ></div>
                            )}
                          </div>
                        )}

                        <div className='form-group col-md-12 padleft d-none'>
                          <label className='control-label' htmlFor='gender'>
                            Examination Number of{' '}
                            {props.currentSitting === 'firstSitting'
                              ? '1st Sitting'
                              : '2nd Sitting'}
                            <span id='compulsory'>*</span>
                          </label>
                          <div className='input-group'>
                            <div className='input-group-prepend'>
                              <div className='input-group-text'>
                                <i className='fa fa-file text-default'></i>
                              </div>
                            </div>
                            <input
                              type='text'
                              id={
                                props.currentSitting === 'firstSitting'
                                  ? 'firstSittingRegNo'
                                  : 'secondSittingRegNo'
                              }
                              name={
                                props.currentSitting === 'firstSitting'
                                  ? 'firstSittingRegNo'
                                  : 'secondSittingRegNo'
                              }
                              className='custom-form-control form-control'
                              placeholder='Examination Number'
                              value={
                                props.currentSitting === 'firstSitting'
                                  ? props.formData.firstSittingRegNo
                                  : props.formData.secondSittingRegNo
                              }
                              onChange={props.changeFormData}
                            />
                          </div>
                          <small className='error-value'>
                            {props.examNoError}
                          </small>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <SSCERecordUpload
            ninValidated={props.ninValidated}
            boxErrorMessage={props.boxErrorMessage}
            displayForm={props.displayForm}
            sittings={props.sittings}
            loadAssert={props.loadAssert}
            subArray={props.subArray}
            handleFirstSittingChange={props.handleFirstSittingChange}
            handleSecondSittingChange={props.handleSecondSittingChange}
            validateFormRow={props.validateFormRow}
          />
          <div
            className={` text-center  text-dark concent p-3${
              !props.ninValidated || props.boxErrorMessage ? ' d-none' : ''
            } ${!props.displayForm ? ' d-none' : 'd-block'}`}
          >
            <div className='font-weight-bold text-danger m-1'>
              By submission, you have agreed that all documents and information
              given are complete and accurate, false information may lead to
              automatic disqualification
            </div>
            <div className='text-black font-weight-bolder m-1'>
              <input
                onChange={props.changeConsent}
                type='checkbox'
                className='checkb'
              />
              &nbsp;&nbsp;&nbsp;I consent that every information provided on
              this form is true
            </div>
          </div>
          <div className='d-flex justify-content-between '>
              <div className='p-4'>
            <button className='btn btn-outline-secondary' onClick={() => { props.setCurrentPage(props.currentPage - 1) } }>Previous page</button>
          </div>
          <div
            className={`border-0 offset-2 p-4 ${
              !props.ninValidated || props.boxErrorMessage ? ' d-none' : ''
            } ${!props.displayForm ? ' d-none' : 'd-block'}`}
          >
            <button
              disabled={!props.consent || props.loading.submit || (examValidator.examType === '' && examValidator.examYear === '' && examValidator.examNo === '')}
              type='submit'
              className='btn btn-block shadow  rounded btn-success'
            >
             Proceed to Preview{' '}
              {props.loading.submit && (
                <div className='spinner-border spinner-border-sm'></div>
              )}
            </button>
          </div>
          </div>
          {/* <button
            id='myBtn'
            title='Go to top'
            className={`btn btn-dark to-top btn-progress${
              !props.ninValidated || props.boxErrorMessage ? ' d-none' : ''
            } ${!props.displayForm ? ' d-none' : 'd-block'}`}
          >
            <i className='fa fa-caret-up fa-x5'></i>
          </button> */}
        </>
      )}
    </div>
  );
}
